'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (theme, props, state) {
    var palette = theme.palette,
        appearance = theme.appearance;


    if (state.hover) {
        appearance = theme.appearanceHover;
    }

    if (props.disabled) {
        appearance = theme.appearanceDisabled;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            display: theme.display,
            width: theme.width,
            minWidth: theme.minWidth
        },
        wrapper: {
            position: 'relative'
        },
        calendar: {
            display: 'block',
            position: 'absolute',
            bottom: palette.gutter + 'px',
            right: 0,
            width: '24px',
            height: '24px',
            transitionDuration: palette.transitionDuration,
            transitionTimingFunction: palette.transitionFunction,
            transitionProperty: 'background-image',
            backgroundImage: 'url("' + appearance + '")',
            backgroundSize: 'contain',
            cursor: props.disabled ? 'default' : 'pointer'
        },
        picker: {
            position: 'absolute',
            zIndex: theme.zIndex
        },
        animation: {
            transition: 'opacity 300ms ' + palette.transitionFunction + ', transform 450ms ' + palette.transitionFunction,

            '&-enter': {
                opacity: 0.5,
                transform: 'scaleY(0)'
            },

            '&-enter-active': {
                opacity: 1,
                transform: 'scaleY(1)'
            },
            '&-exit': {
                opacity: 1,
                transform: 'scaleY(1)'
            },
            '&-exit-active': {
                opacity: 0,
                transform: 'scaleY(0)'
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        wrapper: (0, _aphroditeJss.css)(styleList.wrapper),
        calendar: (0, _aphroditeJss.css)(styleList.calendar),
        picker: (0, _aphroditeJss.css)(styleList.picker),
        animation: (0, _aphroditeJss.css)(styleList.animation)
    };
};

var _aphroditeJss = require('aphrodite-jss');